import { TextButton } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import {
  EXP_SIGNUP_MODAL_SHARE_PAGE,
  ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE,
} from 'constants/featureFlag';
import { SIGNUP_MODAL } from 'constants/modalTypes';
import { LOGIN_PAGE } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import { isMobile } from 'utilities/device';
import { getFlagValueForUser } from 'utilities/featureFlag';

export default function SigninButton({ tracking, size }) {
  const dispatch = useDispatch();

  const signinOnClick = async () => {
    analytics.track(tracking.eventName, tracking.properties);

    const showSignupModal = await getFlagValueForUser(
      ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE
    );

    if (isMobile) {
      window.location.href = LOGIN_PAGE;
    } else {
      const experimentShowModal = await getFlagValueForUser(
        EXP_SIGNUP_MODAL_SHARE_PAGE
      );

      if (showSignupModal && experimentShowModal === 'variant') {
        dispatch(openModal(SIGNUP_MODAL, { signupMode: false }));
      } else {
        window.location.href = LOGIN_PAGE;
      }
    }
  };

  return (
    <TextButton onClick={signinOnClick} size={size}>
      Sign in
    </TextButton>
  );
}
